interface AnalyticsPayload {
  [key: string]: unknown;
}

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export const emitAnalytics = (event: string, payload: AnalyticsPayload = {}) => {
  if (window.dataLayer === undefined) {
    window.dataLayer = [];
  }

  window.dataLayer.push({
    event,
    ...payload
  });
};
